import { FC, useState } from "react";
import { BaseGridProperties } from "../../../BaseGrid/BaseGridProperties";
import BaseGrid from "../../../BaseGrid/BaseGrid";
import { useBaseGrid } from "../../../BaseGrid/Hooks/useBaseGrid";
import InsuredDividendPaymentModal, {
  InsuredDividendPaymentModalConfig,
} from "./InsuredDividendPaymentModal";
import { Box, IconButton } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import { OptionsContextActionParameterProperties } from "../../../TrueUI/Tables/BaseTable2/TableProperties";

type PolicyDividendsTableProps = {
  insuredId?: number;
};

const tableName = "InsuredDividends";
const PolicyDividendsTable: FC<PolicyDividendsTableProps> = ({ insuredId }) => {
  const [modalConfig, setModalConfig] =
    useState<InsuredDividendPaymentModalConfig>({
      insuredId: insuredId,
      progranDividendId: null,
      isOpen: null,
    });

  const actionsForRows = (
    actionOptions: OptionsContextActionParameterProperties<any>
  ) => {
    return (
      <Box>
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() =>
            setModalConfig({
              ...modalConfig,
              progranDividendId: actionOptions.row.ProgramDividendId,
              isOpen: true,
            })
          }
        >
          <LaunchIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  };

  const tableConfig: BaseGridProperties = {
    name: tableName,
    getURL: `api/InsuredDividend/GetInsuredDividendsTable?insuredId=${insuredId}`,
    toolbarOptions: {
      showSortFilter: false,
      showImportButton: false,
      showAddButton: false,
      showEditButton: false,
    },
    columnOptions: [
      { fieldName: "DividendDescription", width: 19 },
      { fieldName: "DeclaredYear", width: 10 },
      { fieldName: "TotalProgram", width: 17, align: "right" },
      { fieldName: "InsuredAmount", width: 17, align: "right" },
      { fieldName: "PaidToDate", width: 17, align: "right" },
      { fieldName: "LastPayment", width: 20 },
    ],
    advancedOptions: {
      optionsColumnConfiguration: {
        isHidden: false,
        optionType: "component",
      },
      optionsContextActions: {
        contextComponent: (actionOptions) => actionsForRows(actionOptions),
      },
    },
  };

  useBaseGrid(tableConfig);

  const setIsOpen = (open: boolean) => {
    setModalConfig({ ...modalConfig, isOpen: open });
  };

  return (
    <div>
      <BaseGrid name={tableName} />
      {modalConfig.isOpen === true && (
        <InsuredDividendPaymentModal
          modalConfig={modalConfig}
          setIsOpen={setIsOpen}
        />
      )}
    </div>
  );
};

export default PolicyDividendsTable;
